module.exports = __webpack_public_path__ + "img/superlotto_white.7ccfe0ec.png";